import { MessageComponentPrefix } from "@/User/Components/Breadcrumb/Utils/MessageBreadcrumb";
import { usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";

export const TAB_ALL = 'all';
export const TAB_APPLY = 'apply';
export const TAB_SCOUT = 'scout';

export const useTabBar = () => {
    const { component } = usePage();

    const [selectedTab, setSelectedTab] = useState(TAB_ALL);

    // State to check tab first loading
    const [allInited, setAllInited] = useState(false);
    const [applyInited, setApplyInited] = useState(false);
    const [scoutInited, setScoutInited] = useState(false);

    const tabList = [
        {
            id: TAB_ALL,
            label: 'すべて',
        },
        {
            id: TAB_APPLY,
            label: '応募',
        },
        {
            id: TAB_SCOUT,
            label: 'スカウト',
        }
    ];

    const handleInit = () => {
        if (selectedTab === TAB_ALL) {
            !allInited && setAllInited(true);
        } else if (selectedTab === TAB_APPLY) {
            !applyInited && setApplyInited(true);
        } else {
            !scoutInited && setScoutInited(true);
        }
    };

    useEffect(() => {
        if (!component.startsWith(MessageComponentPrefix)) {
            selectedTab !== TAB_ALL && setSelectedTab(TAB_ALL);
            allInited && setAllInited(false);
            applyInited && setApplyInited(false);
            scoutInited && setScoutInited(false);
        }
    }, [component]);

    return {
        tabList, selectedTab, setSelectedTab,
        allInited, scoutInited, applyInited, handleInit,
    };
};
